import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { appPrompt, appConfirm } from "@/components/AppDialogHost";

export default function MagCategories() {
  const [cats, setCats] = useState([]);
  const load = () => api.get("/mag/categories").then((r) => setCats(r.data.categories || []));
  useEffect(() => { load(); }, []);

  const add = async () => {
    const name = await appPrompt("Category name:");
    if (!name) return;
    const group = await appPrompt("Group (Music / Features / Media / Culture):", "Music") || "Music";
    await api.post("/mag/categories", { name, group, order: cats.length });
    toast.success("Category added"); load();
  };
  const rename = async (c) => {
    const name = await appPrompt("Rename category:", c.name);
    if (!name) return;
    await api.put(`/mag/categories/${c.category_id}`, { name, group: c.group, order: c.order });
    load();
  };
  const move = async (c, dir) => {
    await api.put(`/mag/categories/${c.category_id}`, { name: c.name, group: c.group, order: c.order + dir * 1.5 });
    load();
  };
  const del = async (c) => {
    if (!await appConfirm(`Remove "${c.name}"?`)) return;
    await api.delete(`/mag/categories/${c.category_id}`); load();
  };

  const groups = [...new Set(cats.map((c) => c.group))];
  return (
    <div className="space-y-4 max-w-3xl" data-testid="mag-categories">
      <div className="flex items-center justify-between">
        <h1 className="font-display text-2xl font-bold">Categories</h1>
        <button onClick={add} data-testid="mag-add-category-btn" className="rounded-full bg-brand-amber text-black px-4 py-2 text-sm font-bold">Add Category</button>
      </div>
      {groups.map((g) => (
        <div key={g} className="rounded-xl border border-line bg-bg-surface">
          <div className="px-4 py-2 border-b border-line text-[10px] font-mono uppercase tracking-wider text-ink-muted">{g}</div>
          <div className="divide-y divide-line">
            {cats.filter((c) => c.group === g).map((c) => (
              <div key={c.category_id} className="flex items-center gap-2 px-4 py-2" data-testid={`mag-cat-row-${c.slug}`}>
                <span className="flex-1 text-sm font-semibold">{c.name}</span>
                <span className="text-[10px] font-mono text-ink-muted">/{c.slug}</span>
                <button onClick={() => move(c, -1)} className="px-1.5 text-ink-muted hover:text-ink-primary">↑</button>
                <button onClick={() => move(c, 1)} className="px-1.5 text-ink-muted hover:text-ink-primary">↓</button>
                <button onClick={() => rename(c)} className="px-2 py-0.5 text-xs rounded border border-line">Edit</button>
                <button onClick={() => del(c)} className="px-2 py-0.5 text-xs rounded border border-line text-red-300/80">Remove</button>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
